export default "__VITE_ASSET__ZFT_74$d__"